import { Subject, Observable } from "rxjs";
import { Screens } from "../models/shared.models";

export class ActiveNavScreenService {
  private navStateChange$: Subject<Screens> = new Subject<Screens>();

  public getNavStateChange$(): Observable<Screens> {
    return this.navStateChange$.asObservable();
  }

  public setNavStateChange(newActiveScreen: Screens): void {
    this.navStateChange$.next(newActiveScreen);
  }
}
